module.exports = "/_next/static/images/fbec030b92a81c77817f92aab3c08038-challenge-the-system-md@3x.jpg.webp";